<template>
  <router-link
    :to="redirectLink"
    class="category-item">
    <img
      v-lazy="imgObj"
      :alt="title"
      class="img-responsive">
    <p class="main-title">{{ title }}</p>
    <premium-indicator v-show="isPremium"/>
  </router-link>
</template>
<script>
import PremiumIndicator from './PremiumIndicator';
import ErrorPlaceholder from '../assets/images/placeholder.png';

export default {
  name: 'CategoryItem',
  components: {
    'premium-indicator': PremiumIndicator,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    picture: {
      type: String,
      default: '',
    },
    isPremium: {
      type: Boolean,
      default: false,
    },
    redirectLink: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ErrorPlaceholder,
      imgObj: {
        src: this.picture,
        error: ErrorPlaceholder,
      },
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/mixins.scss", "../assets/scss/variables.scss";
.category-item {
  max-width: 206px;
  max-height: 206px;
  box-sizing: border-box;
  margin-bottom: 30px !important;
  img {
    background: #dedede;
    &[lazy=loading] {
      background: #eee;
    }
  }
  .main-title {
    color: $black;
    margin-top: 16px;
    @include multilinetruncate(14px, 18px, 1);
  }
}
@media (max-width: $xs) {
  .category-item {
    margin-bottom: 0 !important;
    .main-title {
      @include multilinetruncate(13px, 18px, 2);
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/CategoryItem.vue